import React from 'react';
import { ProductUI } from '../types';
import './styles/ProductCard.scss';
import { formatPhotoUrl } from '../utils/formatter';
import { ProductPriceDisplay } from './ProductPriceDisplay';
import { isFishProduct } from '../utils/productPricing';

interface ProductCardProps {
  product: ProductUI;
  onClick: () => void;
  quantity?: number;
  onQuantityChange?: (quantity: number) => void;
  onAddToCart?: (product: ProductUI) => void;
}

export const ProductCard: React.FC<ProductCardProps> = ({
  product,
  onClick,
  quantity,
  onQuantityChange,
  onAddToCart
}) => {
  const handleAddToCart = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onAddToCart) {
      onAddToCart(product);
    }
  };

  const hasPhoto = product.photo && product.photo.trim() !== '';
  const imageUrl = formatPhotoUrl(product.photo);

  if (quantity !== undefined && onQuantityChange) {
    const handleQuantityClick = (e: React.MouseEvent, delta: number) => {
      e.stopPropagation();
      const newQuantity = Math.max(0, quantity + delta);
      onQuantityChange(newQuantity);
    };

    return (
      <div className="product-card" onClick={onClick}>
        <div className="product-card__image">
          {hasPhoto ? (
            <img src={imageUrl} alt={product.name} loading="lazy" />
          ) : (
            <div className="product-card__no-image">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
                <circle cx="8.5" cy="8.5" r="1.5"></circle>
                <polyline points="21 15 16 10 5 21"></polyline>
              </svg>
              <span>Нет фото</span>
            </div>
          )}
        </div>
        
        <div className="product-card__content">
          <h3 className="product-card__title">{product.name}</h3>
          
          <div className="product-card__price">
            <ProductPriceDisplay product={product} quantity={quantity || 1} />
          </div>

          <div className="product-card__quantity-controls">
            <button 
              className="quantity-btn"
              onClick={(e) => handleQuantityClick(e, -1)}
              disabled={quantity === 0}
            >
              −
            </button>
            <span className="quantity-value">{quantity}</span>
            <button 
              className="quantity-btn"
              onClick={(e) => handleQuantityClick(e, 1)}
            >
              +
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="product-card" onClick={onClick}>
      <div className="product-card__image">
        {hasPhoto ? (
          <img src={imageUrl} alt={product.name} loading="lazy" />
        ) : (
          <div className="product-card__no-image">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="1.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <polyline points="21 15 16 10 5 21"></polyline>
            </svg>
            <span>Нет фото</span>
          </div>
        )}
      </div>
      
      <div className="product-card__content">
        <h3 className="product-card__title">{product.name}</h3>
        
        <div className="product-card__price-row">
          <div className="product-card__prices">
            <ProductPriceDisplay
              product={product}
              showWholesale={false}
              showPerFishHint={isFishProduct(product)}
            />
          </div>
        </div>

        {onAddToCart && (
          <button 
            className="product-card__add-btn"
            onClick={handleAddToCart}
          >
            Добавить
          </button>
        )}
      </div>
    </div>
  );
};
